import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeveloperService } from '@app/services';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mnf-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {
  
  @Input() idProject: string; 
  @Input() index: number;
  
  @Output() hideInfoEvent = new EventEmitter<any>();
  
  /** Iconos */
  arrowUpIcon = faChevronUp;

  /** Variable global para almacenar información del proyecto */
  dev: any;

  /** Variable global para almancenar el monto retirado previamente */
  amountWithDraw: any;
  /** Variable global para almancenar el monto disponible a retirar */
  calculateAmount: any;
  /** Variable global para almancenar la comisión a cobrar */
  comisionTotal: any;
  /** Variable global para almancenar el I.V.A a cobrar por el fondeo */
  ivaTotalF: any;
  /** Variable global para almancenar el I.V.A a cobrar por el fondeo por parte de Monific */
  toMonific: any;
  /** Variable global para almancenar el monto neto final */
  amountNetFinal: any;
  /** Variable global para almancenar la CLABE STP del solicitante */
  STPApplicant: any;
  /** Variable global para almancenar el nombre del proyecto del que se va obtener los recursos */
  nameProject: string;

  constructor(private devServ: DeveloperService) { }

  ngOnInit(): void {
    /** Función para obtener información de la wallet del proyecto */
    this.devServ.getInfoDev(this.idProject).subscribe(r => {      
      // Asignar información a variable global
      this.dev = r?.d;
      // Obtener el monto retirado previamente por el solicitante
      this.amountWithDraw = this.dev?.amountWithDraw;
      // Calcular el monto disponible a retirar
      this.calculateAmount = -(this.dev?.amountWithDraw - (this.dev?.participationsTotal - this.dev?.participationsFree) * this.dev?.participationValue);
      // Calcular la comisión total
      this.comisionTotal = this.calculateAmount * this.dev?.commissionWithOutIVA;
      // Calcular el I.V.A
      this.ivaTotalF = (this.comisionTotal * 0.16);
      // Calcular la comisión e I.V.A para Monific
      this.toMonific = this.comisionTotal + this.ivaTotalF;
      // Calcular el monto final a recibir el solicitante
      this.amountNetFinal = this.calculateAmount - this.comisionTotal - this.ivaTotalF;
      // Obtener la STP del solicitante
      this.STPApplicant = this.dev?.stp?.clabe;
      // Obtener el nombre del proyecto
      this.nameProject = this.dev?.name;
    })
  }

  /** Función para ocultar la información del proyecto */
  hideInfo() {;
    return this.hideInfoEvent.emit(-1);
  }

}
